import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1736ab52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-5 container d-flex justify-content-center" }
const _hoisted_2 = { class: "wrap-container bg-white rounded-4 shadow p-lg-5 py-4 px-2" }
const _hoisted_3 = { class: "text-center fw-bold mb-5" }
const _hoisted_4 = { class: "padding-l-r fs-75 mb-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "tab-container mt-4 pt-5 pb-1 px-3" }
const _hoisted_8 = { class: "row mx-0 px-0 justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_9 = { class: "col-lg-12 mt-3 d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import GoldPoint from './components/GoldPoint'
import { Tab } from '@/components/tabs/index.vue'
import TabPanel from '@/components/tabs/panel/TabPanel.vue'
import Tabs from '@/components/tabs/index.vue'
import Leverage from './components/Leverage.vue'
import InviteAlumni from './components/InviteAlumni.vue'
import Menu from './components/Menu.vue'
import History from './components/History.vue'
import Button from '@/components/button/index.vue'
import { ref, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import yelloopPointsService from '@/services/yelloop-points.services.ts'
import { POINT_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tab_active = ref<string>('LeverageCommunityTab1')
const router = useRouter()
const route = useRoute()
const store = useStore()

const data = ref<any>({})
onMounted(async () => {
  try {
    const response = await yelloopPointsService.getMissionsAlumni()
    data.value = response?.data?.data
  } catch (error) {
    console.log(error)
  }
  router.push({ path: route.path, query: { tab: '1' } })
})

// 2022/10/04 CW-VietNC Fix for UAT Phase2#4476: SJ10 (Ph2-R202201007)
const changeActiveTab = (value: string) => {
  if (value === 'LeverageCommunityTab1') router.push({ path: route.path, query: { tab: '1' } })
  else if (value === 'MenuTab3') router.push({ path: route.path, query: { tab: '3' } })
}

watch(
  () => route.query.tab,
  () => {
    if (route.query.tab === '1') tab_active.value = 'LeverageCommunityTab1'
    else if (route.query.tab === '2') tab_active.value = 'InviteAlumniTab2'
    else if (route.query.tab === '3') tab_active.value = 'MenuTab3'
    else if (route.query.tab === '4') tab_active.value = 'ExchangeHistoryTab4'
  }
)

const tabs: Array<Tab> = [
  {
    title: 'コミュニティを活用する',
    alias: '1',
  },
  {
    title: 'アルムナイを招待する',
    alias: '2',
  },
]

const tabsUse: Array<Tab> = [
  {
    title: 'メニュー',
    alias: '3',
  },
  {
    title: '利用履歴',
    alias: '4',
  },
]

const setDefaultPage = () => {
  store.dispatch(POINT_STORE.ACTIONS.SET_PAGE_EXCHANGE, 1)
}

// 2022/10/12 VietNC Scenario test: no side menu UAT#4439(Ph2-R20221021)
const backToLobby = () => {
  router.push(`/${route.path.split('/')[1]}/lobby`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_unref(translate)('point')), 1),
      _createElementVNode("p", _hoisted_4, [
        _createTextVNode(_toDisplayString(_unref(translate)('SJ10title1')) + " ", 1),
        _hoisted_5,
        _createTextVNode(_toDisplayString(_unref(translate)('SJ10title2')) + " ", 1),
        _hoisted_6,
        _createTextVNode(_toDisplayString(_unref(translate)('SJ10title3')), 1)
      ]),
      _createVNode(_unref(GoldPoint), {
        tab_active: tab_active.value,
        changeActiveTab: changeActiveTab
      }, null, 8, ["tab_active"]),
      _createElementVNode("div", _hoisted_7, [
        (tab_active.value === 'LeverageCommunityTab1' || tab_active.value === 'InviteAlumniTab2')
          ? (_openBlock(), _createBlock(Tabs, {
              key: 0,
              tabs: tabs,
              "default-alias": '1',
              class: "mb-4",
              screen: 'points'
            }, {
              default: _withCtx(() => [
                _createVNode(TabPanel, {
                  alias: '1',
                  keyName: 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(Leverage, { data: data.value }, null, 8, ["data"])
                  ]),
                  _: 1
                }),
                _createVNode(TabPanel, {
                  alias: '2',
                  keyName: 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(InviteAlumni, { data: data.value }, null, 8, ["data"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(Tabs, {
              key: 1,
              tabs: tabsUse,
              "default-alias": '3',
              class: "mb-4",
              screen: 'points'
            }, {
              default: _withCtx(() => [
                _createVNode(TabPanel, {
                  alias: '3',
                  keyName: 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(Menu)
                  ]),
                  _: 1
                }),
                _createVNode(TabPanel, {
                  alias: '4',
                  keyName: 4,
                  onClick: setDefaultPage
                }, {
                  default: _withCtx(() => [
                    _createVNode(History)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(Button, {
            title: _unref(translate)('CO40buttonTop'),
            type: 'secondary',
            onClick: backToLobby
          }, null, 8, ["title"])
        ])
      ])
    ])
  ]))
}
}

})